import axios from 'axios'
import { host } from '../../helper/config'

export const login = async (email, password) => {

    // var salt = bcrypt.genSaltSync(5);
    // var hash = bcrypt.hashSync(password, salt);

    try {
        const response = await axios.post(host + '/admin-lottmekong-login', {
            email,
            password
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        })

        if (response && response.status === 200) {
            if (!response.data || !response.data.token) {
                throw new Error('Token không hợp lệ. Vui lòng thử lại.')
            }
            return response.data
        }
        
        throw new Error('Đăng nhập thất bại. Vui lòng thử lại.')
    } catch (error) {
        // Handle different error types
        if (error.response) {
            // Server responded with error status
            const status = error.response.status
            const message = error.response.data?.message
            
            if (status === 401) {
                throw new Error('Email hoặc mật khẩu không đúng.')
            } else if (status === 500) {
                throw new Error('Lỗi máy chủ. Vui lòng thử lại sau.')
            } else if (message) {
                throw new Error(message)
            } else {
                throw new Error('Đăng nhập thất bại. Vui lòng thử lại.')
            }
        } else if (error.request) {
            // Request was made but no response received
            throw new Error('Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng.')
        } else if (error.message) {
            // Custom error message
            throw error
        } else {
            // Unknown error
            throw new Error('Đã xảy ra lỗi. Vui lòng thử lại.')
        }
    }
}

export const logout = async (token) => {

    const response = await axios.post(host + '/admin-lottmekong-logout', {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: token
          }
    })

    if (response && response.status === 200) {
        return response.data.token || ''
    }
    return ''
}

export const checkToken = async (token) => {

    try {
        const response = await axios.post(host + '/admin-lottmekong-check-token', {}, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: token
              }
        })
    
        if (response && response.status === 200) {
            return response.data || null
        }
        return null
    } catch (error) {
        return null
    } 
}

// export const register = async () => {
//     const response = await axios.post(host + '/admin-lottmekong-register', {
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//         },
//     })

//     if (response && response.status === 200) {
//         return response.data || {}
//     }
//     return {}
// }